module.exports = __webpack_public_path__ + "img/ic_app_instroduce_content.dc7526b3.png";